export enum PostViewerRoute {
  Preview = 'preview',
  Insights = 'insights',
}
